enum QuizzTypeEnum
    {
        sum = 0,
        minimum,
        decrease,
        nomark,
        sumDividedBy10,
        sumMore10
    }

export default QuizzTypeEnum;